import { FxIdApplicationStoreCreatePaymentHandlerEmbeddingType, FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus, FxIdDomainSettingsEGameOrientation, FxIdDomainStoreEnumsSupportedWebPublishingPlatform, } from "@fxid/openapi-client";
import OpenApiClient from "@fxid/openapi-client";
import { EFxIdSdkAdapterInfoSocialCapability, FxIdSdkAdapterStickyBannerShowErrorReason } from "@fxid/sdk-core";
import log, { getAuthToken, registerYandexStorage } from "@fxid/shared";
import { FxIdSdkBaseAdapter } from "./FxIdSdkBaseAdapter";
export class FxIdSdkAdapterForYandexGames extends FxIdSdkBaseAdapter {
    constructor(exportedSdk, game, config, dependencies) {
        super(exportedSdk, game, config, dependencies);
        this.exportedSdk = exportedSdk;
        this.game = game;
        this.config = config;
        this.adapter = "yandex";
    }
    RegisterShareHandlers() {
        return Promise.resolve();
    }
    async BuyProduct(request) {
        const player = await this.sdk.getPlayer({ signed: true });
        // if (player.getMode() === "lite") {
        // 	log.info("Player not authenticated. Authenticating");
        // 	await this.sdk!.auth.openAuthDialog();
        // 	log.info("Player authenticated. Reloading");
        // 	document.location.reload();
        // }
        // log.info("Player authenticated: %o", player);
        const yandexPayments = await this.sdk.getPayments({ signed: true });
        const paymentRequest = {
            Token: getAuthToken(),
            Game: this.game,
            Sku: request.sku,
            WebPublishingPlatform: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.YandexGames,
            EmbeddingType: FxIdApplicationStoreCreatePaymentHandlerEmbeddingType.Embed,
            ProductDescriptionHint: request.productDescriptionHint,
            ProductNameHint: request.productNameHint
        };
        if (request.developerPayload != null) {
            paymentRequest.DeveloperPayload = {
                MerchantDeveloperPayload: request.developerPayload
            };
        }
        const createPaymentResult = await OpenApiClient.Store.fxIdWebFeaturesStoreCreatePaymentEndpoint(paymentRequest);
        log.info("Received result from server: %o", createPaymentResult);
        try {
            log.info("Requesting payment from yandex");
            const purchase = await yandexPayments.purchase({
                id: createPaymentResult.YandexGames.StoreSpecificOrderProductSku,
                developerPayload: JSON.stringify({
                    public_order_id: createPaymentResult.TransactionId
                })
            });
            await this.VerifyPurchase(purchase, yandexPayments);
            await OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Completed
            }).catch((e) => log.error("[YANDEX] Failed to set optimistic status:", e));
            return {
                transactionId: createPaymentResult.TransactionId,
                stats: {
                    currency: createPaymentResult.OrderProduct.Currency ?? "",
                    currencyAmount: createPaymentResult.OrderProduct.Price ?? 0,
                    usdAmount: createPaymentResult.OrderProduct.UsdPrice ?? 0
                }
            };
        }
        catch (error) {
            await OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Cancelled
            }).catch((e) => log.error("[YANDEX] Failed to set optimistic status:", e));
            throw error;
        }
    }
    async VerifyPurchase(purchase, yandexPayments) {
        log.info("Verifying payment on server %o", purchase);
        const response = await OpenApiClient.YandexGames.fxIdWebFeaturesStoreYandexGamesPurchaseEndpoint(this.game, {
            YandexSignedData: purchase.signature,
            YandexGetPurchasesRequest: false
        });
        log.info("Received response from server: %o", response);
        const responsePurchase = response.TokenSuccesses[0];
        if (!responsePurchase.Success) {
            throw new Error(`Purchase not validated ${JSON.stringify(responsePurchase.PurchaseToken)}`);
        }
        log.info("Purchase %s validated", responsePurchase.PurchaseToken);
        await yandexPayments.consumePurchase(responsePurchase.PurchaseToken);
    }
    async GetSocialInfo() {
        const userInfo = await this.GetPlayer();
        return Promise.resolve({
            social: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.YandexGames,
            paymentsAvailable: true,
            userId: userInfo.getUniqueID(),
            capabilities: [
                EFxIdSdkAdapterInfoSocialCapability.OutgoingLinksForbidden,
                EFxIdSdkAdapterInfoSocialCapability.AdsAvailable,
                EFxIdSdkAdapterInfoSocialCapability.RateApplication
            ],
            socialLocale: this.sdk.environment.i18n.lang
        });
    }
    /**
     * Получает информацию о пользователе без signature (быстрый вызов).
     * Используется для получения базовой информации (ID, режим).
     */
    async GetPlayer() {
        const userInfo = await this.sdk.getPlayer();
        return userInfo;
    }
    /**
     * Получает signature для аутентификации пользователя.
     * Требует больше времени, используется только при логине.
     */
    async GetPlayerSignature() {
        const userInfo = await this.sdk.getPlayer({ signed: true });
        return userInfo;
    }
    async Initialize() {
        log.info("Initializing Yandex adapter");
        await new Promise((resolve) => {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = `https://sdk.games.s3.yandex.net/sdk.js`;
            s.addEventListener("load", function (e) {
                log.info("Script loaded");
                resolve();
            }, false);
            const head = document.getElementsByTagName("head")[0];
            head.appendChild(s);
            log.info("Script added");
        });
        log.info("Initializing yandex sdk");
        this.sdk = await window.YaGames.init({
            signed: true,
            screen: {
                orientation: {
                    value: this.config.GameOrientation === FxIdDomainSettingsEGameOrientation.Horizontal
                        ? "landscape"
                        : "portrait",
                    lock: true
                }
            }
        });
        this.sdk.on('game_api_pause', () => {
            log.info("[YANDEX] Received game_api_pause event");
            this.exportedSdk.DispatchPause();
        });
        this.sdk.on('game_api_resume', () => {
            log.info("[YANDEX] Received game_api_resume event");
            this.exportedSdk.DispatchResume();
        });
        try {
            log.info("Initializing Yandex SafeStorage");
            const safeStorage = await this.sdk.getStorage();
            registerYandexStorage(safeStorage);
        }
        catch (err) {
            log.error("Failed to initialize Yandex SafeStorage", err);
        }
        log.info("Getting player");
        const player = await this.sdk.getPlayer();
        this._dependencies.setUserId(player.getUniqueID());
        this._dependencies.setUserDisplayName(`#${player.getUniqueID()}`);
        log.info("Yandex sdk environment: %o", this.sdk.environment);
    }
    /**
     * Выполняет дополнительную инициализацию после успешного логина пользователя.
     * Проверяет непотребленные покупки и запускает обработку промокодов.
     */
    OnAfterLogin() {
        this.CheckNotConsumedPurchases().then(log.info).catch(log.error);
        this.StartPromoCodes().then(log.info).catch(log.error);
        return super.OnAfterLogin();
    }
    async CheckNotConsumedPurchases() {
        log.info("Checking purchases");
        const yandexPayments = await this.sdk.getPayments({ signed: true });
        const notConsumedPurchases = await yandexPayments.getPurchases();
        // Хотя в доках яндекса написано что тут дескать вернутся все покупки, по факту возвращаются не законсьюмленные и постоянные
        if (notConsumedPurchases.signature == null || notConsumedPurchases.signature.length === 0) {
            log.info("All purchases consumed");
            return;
        }
        log.info("Found not consumed purchases %o", notConsumedPurchases);
        log.info("Verifying payment on server %o", notConsumedPurchases);
        const response = await OpenApiClient.YandexGames.fxIdWebFeaturesStoreYandexGamesPurchaseEndpoint(this.game, {
            YandexSignedData: notConsumedPurchases.signature,
            YandexGetPurchasesRequest: true
        });
        log.info("Received response from server: %o", response);
        for (const token of response.TokenSuccesses) {
            if (!token.Success) {
                log.error("Purchase %s not validated", token.PurchaseToken);
            }
            log.info("Purchase %s validated", token);
            await yandexPayments.consumePurchase(token.PurchaseToken);
        }
    }
    StoreCurrency() {
        return Promise.resolve(undefined);
    }
    StatInitialize(request) {
        // TODO: Это говнокод и его надо убрать - приложения должны вызывать LoadingReady
        // this.sdk!.features.LoadingAPI?.ready();
        return Promise.resolve(undefined);
    }
    StatEvent(request) {
        return Promise.resolve(undefined);
    }
    async StoreAdditionalData() {
        const payments = await this.sdk.getPayments({ signed: true });
        const catalog = await payments.getCatalog();
        return { catalog: catalog };
    }
    async CanReview() {
        const feedback = await this.sdk.feedback.canReview();
        return { canReview: feedback.value };
    }
    async RequestReview() {
        await this.sdk.feedback.requestReview();
        return { shown: true };
    }
    AdsIsVideoReady() {
        this.exportedSdk.DispatchAdsVideoAvailable();
        return Promise.resolve(true);
    }
    AdsShowVideo() {
        let finished = false;
        //Елена Дубровина https://chat.rbwtech.net/rbw/pl/5adbw4dqqpbamx4fgg164bjtmc
        // 8 minutes ago
        // @Михаил Варамашвили  нам надо знать когда окно закроется, потому что мы включаем выключаем игровую музыку,
        // если мы ее выключим на video_did_close - по логике что Алесей выше скинул, она у нас начнет играть до того как рекламное окно уберется.
        // Поэтому нам нужно знать когда окно закрывается чтоб ее включить
        //
        // ВРЕМЕННО отключаем новое поведение для рбв. Надо добавить DispatchAdsWindowClosed
        const WARNING_SKIPPED_EVENT_SENT_ALWAYS_EVENT_ON_ALREADY_FINISHED_AD = import.meta.env.VITE_APP_TENANT_OVERRIDE === "RBW";
        this.sdk.adv.showRewardedVideo({
            callbacks: {
                onOpen: () => {
                    log.info("Video ad open.");
                },
                onRewarded: () => {
                    this.exportedSdk.DispatchAdsFinished();
                    finished = true;
                    log.info("Rewarded!");
                },
                onClose: () => {
                    if (WARNING_SKIPPED_EVENT_SENT_ALWAYS_EVENT_ON_ALREADY_FINISHED_AD) {
                        this.exportedSdk.DispatchAdsSkipped();
                    }
                    else {
                        if (!finished) {
                            this.exportedSdk.DispatchAdsSkipped();
                        }
                    }
                    log.info("Video ad closed.");
                },
                onError: (e) => {
                    this.exportedSdk.DispatchAdsFailed();
                    log.error("Error while open video ad:", e);
                }
            }
        });
        return Promise.resolve();
    }
    AdsIsInterstitialReady() {
        this.exportedSdk.DispatchAdsInterstitialAvailable();
        return Promise.resolve(true);
    }
    AdsShowInterstitial() {
        this.sdk.adv.showFullscreenAdv({
            callbacks: {
                onOpen: () => {
                    log.info("InterstitalAdv ad open.");
                },
                onClose: (wasShown) => {
                    if (wasShown) {
                        this.exportedSdk.DispatchAdsFinished();
                        log.info("Rewarded!");
                    }
                    else {
                        this.exportedSdk.DispatchAdsSkipped();
                        log.info("InterstitalAdv ad closed.");
                    }
                },
                onError: (error) => {
                    this.exportedSdk.DispatchAdsFailed();
                    log.error("Error while open video ad:", error.message);
                }
            }
        });
        return Promise.resolve();
    }
    async AdsStickyBannerShow() {
        const { stickyAdvIsShowing, reason } = await this.sdk.adv.getBannerAdvStatus();
        log.info("[YSDK] getBannerAdvStatus result. stickyAdvIsShowing: %o, reason: %o", stickyAdvIsShowing, reason);
        if (stickyAdvIsShowing) {
            return { success: true };
        }
        else if (reason) {
            // Реклама не показывается.
            log.info(reason);
            return {
                success: false,
                errorReason: reason === "ADV_IS_NOT_CONNECTED"
                    ? FxIdSdkAdapterStickyBannerShowErrorReason.AdsNotConnected
                    : FxIdSdkAdapterStickyBannerShowErrorReason.Unknown
            };
        }
        else {
            const showResult = await this.sdk.adv.showBannerAdv();
            log.info("[YSDK] showBannerAdv result. result: %o", showResult);
            if (showResult.reason) {
                return {
                    success: false,
                    errorReason: showResult.reason === "ADV_IS_NOT_CONNECTED"
                        ? FxIdSdkAdapterStickyBannerShowErrorReason.AdsNotConnected
                        : FxIdSdkAdapterStickyBannerShowErrorReason.Unknown
                };
            }
            else {
                return { success: true };
            }
        }
    }
    async AdsStickyBannerHide() {
        const result = await this.sdk.adv.hideBannerAdv();
        log.info("[YSDK] hideBannerAdv result: %o", result);
        return { success: true };
    }
    async LoadingReady() {
        this.sdk.features.LoadingAPI?.ready();
        void super.LoadingReady();
    }
    async GameStarted() {
        this.sdk.features.GameplayAPI?.start();
        void super.GameStarted();
    }
    async GameStopped() {
        this.sdk.features.GameplayAPI?.stop();
        void super.GameStopped();
    }
    async StartPromoCodes() {
        log.info("Start loading promo codes...");
        await this.ConsumeBonuses();
        this.sdk.on("BONUS_AWARDED", async (bonus) => {
            log.info("Received BONUS_AWARDED event: %o", bonus);
            // Александр Смолин, [27 Mar 2025 at 10:41:28]:
            // Да, все верно. Пока нужно работать через getPlayerBonuses в любых кейсах. Способ с данными пока не поддержан.
            await this.ConsumeBonuses();
        });
    }
    async consumeBonus(bonus) {
        try {
            // начислить игроку соответствующий предмет в данных игры, например
            const result = await OpenApiClient.YandexGames.fxIdWebFeaturesStoreYandexGamesRedeemYandexBonusEndpoint({
                GameSystemName: this.config.GameSystemName,
                YandexSecret: bonus.signature
            });
            log.info("Redeem bonus result: %o", result);
            if (result.Success) {
                for (const record of result.Data.Records) {
                    if (record.SucccessData != null) {
                        // консумировать бонус
                        await this.sdk.bonuses.consume(record.SucccessData.ConsumeToken);
                        log.info("Bonus %s successfully consumed: %o", record);
                    }
                    else {
                        log.error("Failed to consume bonus %s: %o", record);
                    }
                }
            }
            else {
                log.error("Failed to redeem bonus: %o", result);
            }
        }
        catch (e) {
            log.error("Failed to consume bonus %o:", bonus, e);
        }
    }
    async ConsumeBonuses() {
        log.info("Start consuming bonuses...");
        try {
            // Request player bonuses
            const receivedBonuses = await this.sdk.bonuses.getPlayerBonuses();
            log.info("Received bonuses: %o", receivedBonuses);
            // Check if bonuses with a signature were received before consuming
            if (receivedBonuses && receivedBonuses.signature) {
                await this.consumeBonus(receivedBonuses);
            }
            else {
                log.info("No pending bonuses found.");
            }
        }
        catch (e) {
            log.error("Failed to get player bonuses:", e);
        }
    }
}
